import { useLocale } from "@translations/locale-context";
import { FaqQuestion } from "@ui/components/faqs/types";
import { Icon } from "@ui/components/icon/icon";
import { slugify } from "@uxf/core/utils/slugify";
import { TextLink } from "@uxf/ui/text-link";
import Link from "next/link";
import React, { FC } from "react";

export const FaqLinkTile: FC<FaqQuestion> = ({ id, seo, question }) => {
    const locale = useLocale();

    return (
        <Link
            href={`${locale === "cs" ? "/caste-otazky" : "/en/faq"}/${id}/${slugify(seo.name || question)}`}
            passHref
            legacyBehavior
        >
            <TextLink className="ui-typo-medium flex min-h-24 w-full items-center justify-between space-x-4 px-6 py-2 text-left text-primary">
                <span>{question}</span>
                <Icon name="chevronRight" size={24} />
            </TextLink>
        </Link>
    );
};
